<template>
    <div v-for="item in getPageContent.pageContent.PCM.WP" :key="item?.WPName" v-show="item?.WPName === 'pagecontent'">
        <div :class="item?.WPName" v-html="item?.WPC"></div>
    </div>
</template>

<script>
import { store } from '../store/store'

export default {
    computed: {
        getPageContent() {
            return {
                pageContent: store.pageContent
            };
        }
    },
}
</script>

<style scoped>
@media (min-width: 1024px) {}
</style>
